var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCiti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.6951C0 13.7373 4.05949 9.87891 9.34587 9.87891C12.4064 9.87891 15.2021 11.2432 16.7978 13.3048L14.5015 15.5977C13.3718 14.1026 11.4075 13.0702 9.37939 13.0702C6.21829 13.0702 3.69075 15.4301 3.69075 18.6918C3.69075 21.9534 6.21829 24.3469 9.37939 24.3469C11.5751 24.3469 13.5394 23.2507 14.6691 21.7188L16.9318 23.948C15.3999 26.1101 12.4734 27.5382 9.34922 27.5382C4.05949 27.5382 0.00335218 23.6798 0.00335218 18.6918",
    fill: "url(#paint0_linear_1876_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5528 10.4775H19.9258V26.9434H23.5528V10.4775Z",
    fill: "url(#paint1_linear_1876_4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3044 22.5216V13.5411H26.3455V10.4806H30.472V6.95412L33.8644 5.28809V10.4773H39.2513V13.5378H33.8644V21.9216C33.8644 23.5843 34.7963 24.315 36.5595 24.315C37.4579 24.315 38.3228 24.1474 39.2212 23.7485V26.8761C38.2893 27.3085 37.1596 27.5398 35.8958 27.5398C32.671 27.5398 30.3077 25.7766 30.3077 22.5183",
    fill: "url(#paint2_linear_1876_4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7379 10.4775H42.1108V26.9434H45.7379V10.4775Z",
    fill: "url(#paint3_linear_1876_4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7978 0C39.12 0 44.6075 3.09406 47.9999 7.8508H43.7762C41.0475 4.82378 37.2562 2.95997 32.7978 2.95997C28.3394 2.95997 24.5481 4.82378 21.8194 7.8508H17.5957C20.9881 3.09406 26.4756 0 32.7978 0Z",
    fill: "url(#paint4_linear_1876_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1876_4",
    x1: 24.3395,
    y1: 101.574,
    x2: -27.5884,
    y2: -33.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482422,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1876_4",
    x1: 25.1397,
    y1: 95.9765,
    x2: -38.2371,
    y2: 58.2392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482422,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1876_4",
    x1: 44.8977,
    y1: 120.83,
    x2: -43.4365,
    y2: -17.6616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482422,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1876_4",
    x1: 47.3247,
    y1: 95.9765,
    x2: -16.052,
    y2: 58.2392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482422,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1876_4",
    x1: 61.3018,
    y1: 40.7652,
    x2: 54.7948,
    y2: -27.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482422,
    stopColor: "white",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiti);
export default __webpack_public_path__ + "static/media/citi.71ab9a2618bf989d65140a652fb1a942.svg";
export { ForwardRef as ReactComponent };